export default __webpack_public_path__ + "static/media/gallery-articles_00.a1a7ba5c.jpg";